import * as types from '../constants/actionTypes';
const IMAGE_UPLOAD_ERROR =
    'Noe gikk galt under opplasting av bilde. Prøv bildekomprimering dersom filstørrelsen er veldig stor.';

const initialState = {
    message: '',
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.SHOW_BROADCAST:
            return {
                ...state,
                message: action.message,
            };

        case types.REMOVE_BROADCAST:
            return {
                ...state,
                message: '',
            };

        case types.UPLOAD_PROFILE_BACKGROUND_FAIL:
        case types.UPLOAD_IMAGE_FAIL:
            return { message: IMAGE_UPLOAD_ERROR };

        default:
            return state;
    }
}
